import { PurchaseAgreementListApp } from "document/list/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const purchaseAgreementRoute: RouteObject = {
  path: "purchaseagreement",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: PurchaseAgreementListApp,
  }]
};